import React, { useEffect, useState } from "react";
import { ImpersonateStore, getCurrentSession, startNewSession, endCurrentSession } from "./store";
import UserLookup from "./lookup";

const ImpersonateAdminIndex = () => {
    const [userIdToImpersonate, setUserIdToImpersonate] = useState("");
    const { impersonatedUserDisplayName, impersonatedUserId, isImpersonating, imperonationEnabled } = ImpersonateStore.useState((s) => {
        return {
            impersonatedUserId: s.impersonatedUserId,
            impersonatedUserDisplayName: s.impersonatedUserDisplayName,
            isImpersonating: s.isImpersonating,
            imperonationEnabled: s.impersonationEnabled,
        };
    });
    useEffect(() => {
        getCurrentSession();
    }, []);

    return (
        <div>
            <h1>Impersonate</h1>
            {!isImpersonating && imperonationEnabled && (
                <>
                    <div className="button-group">
                        <div className="form-field">
                            <label>User ID</label>
                            <input
                                type="text"
                                name="userIdToImpersonate"
                                value={userIdToImpersonate}
                                onChange={(e) => {
                                    setUserIdToImpersonate(e.currentTarget.value);
                                }}
                            />
                        </div>
                        <button
                            className="button -secondary -small"
                            onClick={async () => {
                                if (!userIdToImpersonate) return false;

                                await startNewSession(userIdToImpersonate);
                                window.location.reload();
                            }}
                        >
                            Impersonate
                        </button>
                    </div>
                    <br />
                    <div className="background-line -center -gray">
                        <span className="txt -compressed -uppercase">or</span>
                    </div>
                    <UserLookup />
                </>
            )}
            {isImpersonating && (
                <div>
                    <h2>
                        Impersonation In Progress: {impersonatedUserDisplayName} ({impersonatedUserId})
                    </h2>
                    <button
                        className="button -primary -small"
                        onClick={async () => {
                            await endCurrentSession();
                            window.location.reload();
                        }}
                    >
                        End
                    </button>
                </div>
            )}
            {!imperonationEnabled && <div>Not Enabled</div>}
        </div>
    );
};

export default ImpersonateAdminIndex;
